var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "10px",
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "drop_down_m") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02_\\uC0C1\\uD488\\uB4F1\\uB85D",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02_\\uC0C1\\uD488\\uB4F1\\uB85D_211220",
    transform: "translate(-1379.000000, -803.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CON",
    transform: "translate(263.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC608\\uC57D\\uAD6C\\uB9E4",
    transform: "translate(1.000000, 630.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "title",
    transform: "translate(20.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1094.000000, 1.003853)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(9.000000, 9.000000) scale(1, -1) rotate(90.000000) translate(-9.000000, -9.000000) ",
    x: -2.27373675e-13,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-8",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2 5.5 9 12.5 16 5.5"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.ece4cdc56d19fc818357d9ba126f8673.svg";
export { ForwardRef as ReactComponent };